import { getConfig } from '@/config';
import { buildSessionHeaders } from '@/client/utils';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const getSeoKeywordsUrl = () => `${getConfig().seoManagerApiUrl}/keywords`;
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for SEO keyword suggestions.
 *
 * Endpoints sit under `{seoManagerApiUrl}/keywords`.
 * Auth and tenant headers are handled by the base `ccApi`.
 *
 * Note: These endpoints use an absolute URL because the SEO manager API
 * has a different base URL than the standard CC API.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const seoKeywordApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        // -----------------------------------------------------------------------
        // Queries (using mutations because search is POST-based)
        // -----------------------------------------------------------------------
        searchKeywordSuggestions: builder.mutation({
            query: ({ body }) => ({
                url: `${getSeoKeywordsUrl()}/search`,
                method: 'POST',
                body,
                headers: buildSessionHeaders(),
            }),
        }),
        // -----------------------------------------------------------------------
        // Mutations
        // -----------------------------------------------------------------------
        updateKeywordSuggestionStatus: builder.mutation({
            query: ({ body }) => ({
                url: `${getSeoKeywordsUrl()}/bulkApproval`,
                method: 'POST',
                body,
                headers: buildSessionHeaders(),
            }),
            invalidatesTags: [CC_API_TAGS.SeoKeywordList],
        }),
        bulkAddKeywords: builder.mutation({
            query: ({ body }) => ({
                url: `${getSeoKeywordsUrl()}/bulkAdd`,
                method: 'POST',
                body,
                headers: buildSessionHeaders(),
            }),
            invalidatesTags: [CC_API_TAGS.SeoKeywordList],
        }),
        updateKeyword: builder.mutation({
            query: ({ keywordId, body, areaId }) => ({
                url: `${getSeoKeywordsUrl()}/${encodeURIComponent(keywordId)}`,
                method: 'PATCH',
                body,
                headers: Object.assign(Object.assign({}, buildSessionHeaders()), { 'X-Area-Id': areaId }),
            }),
            invalidatesTags: [CC_API_TAGS.SeoKeywordList],
        }),
    }),
});
export const { useSearchKeywordSuggestionsMutation, useUpdateKeywordSuggestionStatusMutation, useBulkAddKeywordsMutation, useUpdateKeywordMutation, } = seoKeywordApi;
